
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-51122a79&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Messages.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Messages.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-51122a79!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Messages.vue"),
  /* scopeId */
  "data-v-51122a79",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/center/Messages.vue
// module id = 1025
// module chunks = 0